import * as React from "react"
import { FallbackProps } from "react-error-boundary"
import Oops from "./Oops"

// For use with ErrorBoundary from "react-error-boundary"
export const OopsFallback = (props: FallbackProps) => <Oops body={props.error.message} />
